module.exports = __webpack_public_path__ + "fonts/ralewaylightitalic.43b109b.woff2";